import { render, staticRenderFns } from "./EmojiAutocompleteSuggestion.vue?vue&type=template&id=4beabde0&scoped=true"
import script from "./EmojiAutocompleteSuggestion.vue?vue&type=script&lang=js"
export * from "./EmojiAutocompleteSuggestion.vue?vue&type=script&lang=js"
import style0 from "./EmojiAutocompleteSuggestion.vue?vue&type=style&index=0&id=4beabde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beabde0",
  null
  
)

export default component.exports